
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[eventUrl]",
      function () {
        return require("private-next-pages/[eventUrl].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[eventUrl]"])
      });
    }
  